(function () {
    "use strict";

    // @ngInject
    function HomeServiceCtor($state, AppStates, AppConfigService, AnalyticsService, UsersManager, AbTestService, Enums, $rootScope, DeviceService,
                             $q, UiPersistenceService, FeaturesService, _) {
        this.$state = $state;
        this.AppStates = AppStates;
        this.AppConfigService = AppConfigService;
        this.AnalyticsService = AnalyticsService;
        this.UsersManager = UsersManager;
        this.AbTestService = AbTestService;
        this.Enums = Enums;
        this.$rootScope = $rootScope;
        this.DeviceService = DeviceService;
        this.$q = $q;
        this.UiPersistenceService = UiPersistenceService;
        this.FeaturesService = FeaturesService;
        this._ = _;
        this.isMobileDevice = DeviceService.nxSmallBreakpoint();
    }

    Services.HomeService = Class(function () {

        return {

            constructor: HomeServiceCtor,

            shouldShowHome: function shouldShowHome() {
                var user = this.UsersManager.getCurrUser();
                var isPreTrialer = user.shouldStartTrial();
                return !isPreTrialer;
            },

            routeToPipelineOrHome: function routeToPipelineOrHome(ignoreHome) {
                var route = this.getRouteToPipelineOrHome(ignoreHome);
                if (route) {
                    this.$state.go(route);
                }
            },

            getRouteToPipelineOrHome: function getRouteToPipelineOrHome(ignoreHome) {
                if (!this.shouldShowHome()) {
                    return this.AppStates.root_core_navigation_pipeline;
                }
                return this.AppStates.root_core_navigation_home;
            },

            validateUserShouldSeeHome: function validateUserShouldSeeHome() {
                var shouldShowHome = this.shouldShowHome();
                if (!shouldShowHome) {
                    this.$state.go(this.AppStates.root_core_navigation_pipeline);
                }
                return shouldShowHome;
            },

            shouldShowHomeForTrialers: function shouldShowHomeForTrialers() {
                this.currUser = this.UsersManager.getCurrUser();
                var isPreTrialer = this.currUser.shouldStartTrial();
                var isUserSubscribed = this.currUser.companyHasSubscription();
                return (!this.isMobileDevice && !isPreTrialer && !isUserSubscribed);
            }
        };
    });
}());
